import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class LoaderService {
  private isLoadingSubject = new BehaviorSubject<boolean>(false); // Mantener el estado del loader
  isLoading$ = this.isLoadingSubject.asObservable();  // Observable para suscribirse al estado del loader

  show() {
    this.isLoadingSubject.next(true);   // Mostrar el loader (cambia el estado a 'true')
  }

  hide() {
    this.isLoadingSubject.next(false);   // Ocultar el loader (cambia el estado a 'false')
  }
}
